// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UserManagementDropdown_wrapper___tftw","wrapper__container":"UserManagementDropdown_wrapper__container__3fhTS"};